<template>
  <div class="publicMain">
    <el-row class="leftClass">
      <el-col :span="6">
        <label style="width: 100px;">{{ $t('mbgl.codeName') }}：</label>
        <el-input v-model="queryForm.codeName" clearable size="mini" style="width: 60%;"></el-input>
      </el-col>
      <el-col :span="6">
        <label style="width: 100px;">{{ $t('mbgl.codeId') }}：</label>
        <el-input v-model="queryForm.codeId" clearable size="mini" style="width: 60%;"></el-input>
      </el-col>
      <el-col :span="6">
        <label style="width: 100px;">{{ $t('mbgl.state') }}：</label>
        <el-select v-model="queryForm.codeState" :placeholder="$t('common.select') + $t('mbgl.state')" clearable size="small" style="width: 60%;">
          <el-option
            v-for="item in stateOptions"
            :key="item.value[$i18n.locale]"
            :label="item.label[$i18n.locale]"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-button size="mini" type="primary" @click="getCodeInfo('query')">{{ $t('common.searchBtn') }}</el-button>
        <el-button size="mini" @click="resetSearch('reset')">{{ $t('common.resetBtn') }}</el-button>
      </el-col>
    </el-row>
    <el-row class="rightClass">
      <el-col :span="12" style="text-align: left;">
        <el-button size="mini" type="primary" @click="openDialog('add')">{{ $t('common.addedBtn') }}</el-button>
        <el-button size="mini" :disabled="editDisabled" type="success" @click="openDialog('edit', multipleSelection[0])">{{ $t('common.editBtn') }}</el-button>
        <el-button size="mini" :disabled="delDisabled" type="danger" @click="openDialog('del', multipleSelection)">{{ $t('common.deleteBtn') }}</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="tableData" border style="width: 100%; font-size: 12px;"
        :header-cell-style="{background:'#f5f7fa', color:'#909399'}"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50px" align="center"></el-table-column>
        <el-table-column :prop="'desc['+ $i18n.locale + ']'" :label="$t('mbgl.codeName')" align="center"></el-table-column>
        <el-table-column :label="$t('mbgl.codeId')" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="goto(scope.row)">
              {{ scope.row.id }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column :label="$t('mbgl.state')" align="center">
          <template slot-scope="scope">
            {{ scope.row.codeState == '0' ? $t('common.stopState') : $t('common.normalState') }}
          </template>
        </el-table-column>
        <el-table-column prop="updator" :label="$t('common.updator')" align="center"></el-table-column>
        <el-table-column prop="updateAt" :label="$t('common.updateAt')" width="140px" align="center"></el-table-column>
        <el-table-column prop="creator" :label="$t('common.creator')" align="center"></el-table-column>
        <el-table-column prop="createAt" :label="$t('common.createAt')" width="140px" align="center"></el-table-column>
        <el-table-column :label="$t('common.operation')" width="100px" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="openDialog('edit', scope.row)">{{ $t('common.editBtn') }}</el-button>
            <el-button type="text" @click="openDialog('del', [scope.row])">{{ $t('common.deleteBtn') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <!-- 分页组件 -->
      <Pagination :currentPage="currentPage" :total="total" :limit="limit" :small="true" :pageSizes="$store.state.pageSizes"
        @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"/>
    </el-row>
    
    <!-- 编码信息模态框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false"
      :close-on-press-escape="true" @close="handleClose">
      <label slot="title">
        <i :class="dialogTitleIcon" style="font-size: 16px; font-weight: bold;">
          <span style="margin-right: 5px;">
            {{ this.dialogTitle }}
          </span>
        </i>
      </label>
      <el-card style="padding: 0 20% 0 20%">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px"
          :validate-on-rule-change="false" size="small">
          <el-form-item :label="$t('mbgl.codeId')" prop="codeId" class="formClass">
            <el-input v-model="ruleForm.codeId" :placeholder="$t('mbgl.ruleMsg') + $t('mbgl.codeId')" ></el-input>
          </el-form-item>
          <el-form-item :label="$t('mbgl.codeZh')" prop="descZh">
            <el-input v-model="ruleForm.descZh" :placeholder="$t('mbgl.ruleMsg') + $t('mbgl.ruleCodeZh')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mbgl.codeEn')" prop="descEn">
            <el-input v-model="ruleForm.descEn" :placeholder="$t('mbgl.ruleMsg') + $t('mbgl.ruleCodeEn')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mbgl.codeLabel')" prop="code" v-if="addFlg">
            <el-input v-model="ruleForm.code" :placeholder="$t('mbgl.ruleMsg') + $t('mbgl.ruleCodeLabelId')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mbgl.codeLabelZh')" prop="codeNameZh" v-if="addFlg">
            <el-input v-model="ruleForm.codeNameZh" :placeholder="$t('mbgl.ruleMsg') + $t('mbgl.ruleCodeLabelZh')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mbgl.codeLabelEn')" prop="codeNameEn" v-if="addFlg">
            <el-input v-model="ruleForm.codeNameEn" :placeholder="$t('mbgl.ruleMsg') + $t('mbgl.ruleCodeLabelEn')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mbgl.state')" prop="codeState">
            <el-switch class="stateClass"
              v-model="ruleForm.codeState"
              active-value="1"
              inactive-value="0"
              :active-text="$t('common.normalState')"
              :inactive-text="$t('common.stopState')">
            </el-switch>
          </el-form-item>
        </el-form>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">{{ $t('common.cancelBtn') }}</el-button>
        <el-button type="primary" size="small" @click="submitForm('ruleForm')">{{ $t('common.saveBtn') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'mbgl',
  computed: {
    rules() {    // 模态框数据校验规则
      return {
        codeId: [{ required: true, message: this.$t('mbgl.ruleMsg') + this.$t('mbgl.codeId'), trigger: "blur" }],
        code: [{ required: true, message: this.$t('mbgl.ruleMsg') + this.$t('mbgl.ruleCodeLabelId'), trigger: "blur" }],
        codeNameZh: [{ required: true, message: this.$t('mbgl.ruleMsg') + this.$t('mbgl.ruleCodeLabelZh'), trigger: "blur" }],
        codeNameEn: [{ required: true, message: this.$t('mbgl.ruleMsg') + this.$t('mbgl.ruleCodeLabelEn'), trigger: "blur" }],
        descZh: [{ required: true, message: this.$t('mbgl.ruleMsg') + this.$t('mbgl.ruleCodeZh'), trigger: "blur" }],
        descEn: [{ required: true, message: this.$t('mbgl.ruleMsg') + this.$t('mbgl.ruleCodeEn'), trigger: "blur" }],
      }
    },
  },
  data() {
    return {
      tabLoading: false,    // 查询数据loading层
      queryForm: {
        codeName: '',
        codeId: '',
        codeState: '',
      },
      tableData: [],
      editDisabled: true,    // 编辑按钮状态
      delDisabled: true,    // 删除按钮状态
      multipleSelection: [],    // 表格选中行
      stateOptions: [],    // 状态
      currentPage: 1,    // 页码
      limit: this.$store.state.dataDisplayNum,    // 分页显示条数
      total: 0,    // 列表数据量
      pageSizes: this.$store.state.pageSizes,    // 分页显示可选择条数
      dialogFormVisible: false,
      dialogTitle: '',    // 模态框标题
      dialogTitleIcon: '',    // 模态框标题图标
      addFlg: false,
      ruleForm: {
        eidtCodeId: "",
        eidtCodeLabelId: "",
        codeId: "",
        code: "",
        codeNameZh: "",
        codeNameEn: "",
        descZh: "",
        descEn: "",
        codeState: "1",
      },
      saveFlg: '',    // 保存操作区分
    }
  },
  methods: {
    goto(row) {
      this.$router.push({
        name: 'mbxq',
        params: { id: row.id, codeId: row.id }
      })
    },
    /** 获取编码信息 */
    getCodeInfo(typeFlg) {
      let _this = this;
      _this.tableData = [];
      if(typeFlg == 'reset' || typeFlg == 'query' || typeFlg == 'add' || typeFlg == 'edit' || typeFlg == 'del') {
        _this.queryForm.currentPage = 1;
        _this.queryForm.limit = _this.$store.state.dataDisplayNum;
        _this.currentPage = 1;
      } else {
        _this.queryForm.currentPage = _this.currentPage;
        _this.queryForm.limit = _this.limit;
      }
      _this.tabLoading = true;    // 关闭请求时的loading层
      _this.$ajax.post("/api/common/getCodeInfo", _this.queryForm).then((res) => {
        _this.tabLoading = false;    // 关闭请求时的loading层
        let msgCode = res.status;
        if(res.status == '200') {
          if(res.data.code == '200') {
            if(res.data.data.length > 0) {
              _this.total = parseInt(res.data.data[0].tableCount);
            } else {
              _this.total = 0;
            }
            _this.tableData = res.data.data;
          }
        }
      }).catch((error) => {
        _this.tabLoading = false;    // 关闭请求时的loading层
      })
    },
    openDialog(flg, row) {
      if(flg == 'add') {
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.addFlg = true;
          this.dialogTitle = this.$t('mbgl.addCodeData');
          this.dialogTitleIcon = 'el-icon-document-add';
          this.ruleForm.code = '';
          this.ruleForm.codeNameZh = '';
          this.ruleForm.codeNameEn = '';
          this.ruleForm.codeState = '1';
        })
      } else if(flg == 'edit') {
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.addFlg = false;
          this.dialogTitle = this.$t('mbgl.editCodeData');
          this.dialogTitleIcon = 'el-icon-edit-outline';
          this.ruleForm.eidtCodeId = row.id;
          this.ruleForm.eidtCodeLabelId = '';
          this.ruleForm.codeId = row.id;
          this.ruleForm.code = '';
          this.ruleForm.codeNameZh = '';
          this.ruleForm.codeNameEn = '';
          this.ruleForm.descZh = row.descZh;
          this.ruleForm.descEn = row.descEn;
          this.ruleForm.codeState = row.codeState == '0' ? '0' : '1';
        })
      } else if(flg == 'del') {
        let tmpArr = [];
        for(let tmp of row) {
          tmpArr.push(tmp.id + ';');
        }
        this.delCode(tmpArr);
      }
      this.saveFlg = flg;
    },
    /** 保存模态框数据 */
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.saveFlg === 'add') {
            this.addCode();
          } else if(this.saveFlg === 'edit') {
            this.editCode();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /** 添加编码 */
    addCode() {
      let _this = this;
      _this.$ajax.post('/api/common/addCode', _this.ruleForm).then((res) => {
        _this.dialogFormVisible = false;
        let msgCode = res.status;
        if(res.status == '200') {
          if(res.data.code == '200') {
            _this.$message.success(_this.$t('mbgl.addSuccess'));
            _this.getCodeInfo('add');
          }
        }
      }).catch((error) => {
        _this.dialogFormVisible = false;
      });
    },
    /** 编辑编码 */
    editCode() {
      let _this = this;
      _this.$ajax.post('/api/common/updateCode', _this.ruleForm).then((res) => {
        _this.dialogFormVisible = false;
        let msgCode = res.status;
        if(res.status == '200') {
          if(res.data.code == '200') {
            _this.$message.success(_this.$t('mbgl.editSuccess'));
            _this.getCodeInfo('edit');
          }
        }
      }).catch((error) => {
        _this.dialogFormVisible = false;
      });
    },
    /** 删除编码 */
    delCode(dataArr) {
      let _this = this;
      _this.$confirm(_this.$t('common.deleteContent'), _this.$t('common.deleteTitle'), {
        distinguishCancelAndClose: true,
        confirmButtonText: _this.$t('common.confirmBtn'),
        cancelButtonText: _this.$t('common.cancelBtn')
      }).then(res1 => {
        _this.$ajax.post("/api/common/delCode", dataArr).then((res) => {
          let msgCode = res.status;
          if(res.status == '200') {
            if(res.data.code == '200') {
              _this.getCodeInfo('del');
              _this.$message.success(_this.$t('mbgl.delSuccess'));
            }
          }
        })
      }).catch(action => {
        // this.$message.info({
        //   message: action === 'cancel' ? '放弃保存并离开页面' : '停留在当前页面'
        // })
      });
    },
    //重置操作
    resetSearch(typeFlg) {
      this.queryForm.codeName = "";
      this.queryForm.codeId = "";
      this.queryForm.codeState = "";
      this.getCodeInfo(typeFlg);
    },
    handleClose(done) {
      this.$refs['ruleForm'].resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if(this.multipleSelection.length == 1) {
        this.editDisabled = false;
      } else {
        this.editDisabled = true;
      }
      if(this.multipleSelection.length > 0) {
        this.delDisabled = false;
      } else {
        this.delDisabled = true;
      }
    },
    /** 页码改变时会触发 */
    handleCurrentChange(uniqueNum, val) {
      this.currentPage = val;
      this.getCodeInfo();
    },
    /** 每页条数改变时触发 */
    handleSizeChange(uniqueNum, val) {
      this.limit = val;
      this.currentPage = 1;
      this.getCodeInfo();
    },
  },
  mounted() {
    this.getCodeInfo();
    this.$requestUtil.getCodeInfoById(['NORMAL_CODE_STATE']).then(tmpResult => {
      // 状态
      let stateCodeList = tmpResult["NORMAL_CODE_STATE"];
      for(let tmp of stateCodeList){
        this.stateOptions.push({
          label: tmp.name,
          value: tmp.code,
        });
      }
    });
  }
}
</script>

<style lang="scss" scoped>
.rightClass {
  margin: 10px 0;
}
::v-deep .stateClass {
  .el-switch__label--left {
    position: relative;
    left: 52px;
    margin-right: 0;
    color: #fff;
    z-index: -1111;
  }
  .el-switch__core{
    width: 70px !important;
  }
  .el-switch__label--right {
    position: relative;
    right: 52px;
    margin-left: 0;
    color: #fff;
    z-index: -1111;
  }
  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff !important;
  }
  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #9c9c9c !important;
  }
}
</style>